import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_BIZ_USER, IS_ONPREMISE, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

/**
 * CLOUD-4585: Фича для вкл/выкл welcome модалки
 */
export const familyTariffOnboardingModal = isFeature('family-tariff-onboarding-modal');

/**
 * CLOUD-4600: Фича переключения на просмотр паблика членам семьи
 */
export const familyAlmbumPublicLink = isFeature('family-album-public-link');

export const promoQuotaFamilyTariffCreateFamily = getFeature('promo-quota-family-tariff-create-family') || [];

export const familyFeaturePreviewPaid =
    isFeature('family-feature-preview-paid') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && IS_PAID_USER;
export const familyFeaturePreviewFree =
    isFeature('family-feature-preview-free') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER && !IS_PAID_USER;

export const familyFeaturePreview = familyFeaturePreviewPaid || familyFeaturePreviewFree;

export const familyFeaturePreviewProduct = getFeature('family_features_preview_product') || 'W1TB_1y_family_features_a';

export const familyFeaturePreviewFreeAsideTooltip = familyFeaturePreviewFree && isFeature('family-feature-preview-free-aside-tooltip');
export const familyFeaturePreviewPaidAsideTooltip = familyFeaturePreviewPaid && isFeature('family-feature-preview-paid-aside-tooltip');
export const familyFeaturePreviewAsideTooltip = familyFeaturePreviewFreeAsideTooltip || familyFeaturePreviewPaidAsideTooltip;

export const familyFeaturePreviewFreeAlbumsTooltip = familyFeaturePreviewFree && isFeature('family-feature-preview-free-albums-tooltip');
export const familyRouteTextDisabled = isFeature('family-route-text-disabled');
export const familyRouteTariffId = getFeature('family-route-tariff-id') || 'W1TB_1y_family_landing_exp_force_trial';

export const familyFeaturePreviewPaidAlbumsTooltip = familyFeaturePreviewPaid && isFeature('family-feature-preview-paid-albums-tooltip');
export const familyFeaturePreviewAlbumsTooltip = familyFeaturePreviewFreeAlbumsTooltip || familyFeaturePreviewPaidAlbumsTooltip;

export const familyFeatureDropdownPreviewFree =
    isFeature('family-feature-dropdown-preview-free') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER;
export const familyFeatureDropdownPreviewPaid =
    isFeature('family-feature-dropdown-preview-paid') && !IS_BIZ_USER && !IS_ONPREMISE && !IS_B2B_BIZ_USER;

export const familyDocumentsTooltip = isFeature('family-documents-tooltip');

export const familyFeatureDropdownButtons = isFeature('family-feature-dropdown-buttons');

export const familyFeatureDocumentsFree = familyFeaturePreviewFree && isFeature('family-feature-documents-free');
export const familyFeatureDocumentsPaid = familyFeaturePreviewPaid && isFeature('family-feature-documents-paid');
export const familyFeatureDocuments = isFeature('family-feature-documents');

// CLOUD-4701: Фича включает обновленный продающий эмптистейт в разделе «Семья»
export const familyEmptyStateReborn = isFeature('family-empty-state-reborn');
// CLOUD-4701: Фича определяет текст для кнопки в новом продающем эмптистейте
export const familyEmptyStateButtonText = getFeature('family-empty-state-button-text') || 'Попробовать за 1 ₽';

export const familyEnableCalendar = isFeature('family-enable-calendar');
export const familyEnableCalendarFree = isFeature('family-enable-calendar-free');
export const familyEnableCalendarPaid = isFeature('family-enable-calendar-paid');

const familyCalendarModalMonthDefault: Array<string> = [
    'W1TB_1m_family_features_a',
    'W512GB_1m_family_features_discount_3m',
    'W256GB_1m_family_features_discount_3m',
];
const familyCalendarModalTariffsMonth: Array<string> = getFeature('family-calendar-modal-tariffs-month') || familyCalendarModalMonthDefault;

const familyCalendarModalYearDefault: Array<string> = [
    'W1TB_1y_family_features_a',
    'W512GB_1y_family_features_discount',
    'W256GB_1y_family_features_discount',
];
const familyCalendarModalTariffsYear: Array<string> = getFeature('family-calendar-modal-tariffs-year') || familyCalendarModalYearDefault;
export const familyCalendarModalTariffs: { month: Array<string>; year: Array<string> } = {
    month: familyCalendarModalTariffsMonth,
    year: familyCalendarModalTariffsYear,
};

export const familyCalendarsModalTariffsReverse: boolean = isFeature('family-calendar-modal-tariffs-reverse');
